export default __webpack_public_path__ + "static/reviewer-image-6-36bf69b2d6f5ef052bd5fef1503c5a15.png";